import { useState } from 'react';
import Autocomplete from './Autocomplete';

const WidgetSearchBar = ({ category, horizontal }) => {
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <div className="flex w-full">
      <div className="flex-grow">
        <Autocomplete
          category={category}
          currentValue={searchTerm}
          setCurrentValue={setSearchTerm}
          elementId="desktop-search"
          placeholder={
            horizontal
              ? 'Search for events by name, keyword, location, venue...'
              : 'Search for events'
          }
          widget
          resultCount={horizontal ? 1 : undefined}
        />
      </div>
    </div>
  );
};

export default WidgetSearchBar;
